import { render, staticRenderFns } from "./DatasetTabGeneral.vue?vue&type=template&id=6a6db077&scoped=true&lang=pug"
import script from "./DatasetTabGeneral.vue?vue&type=script&lang=js"
export * from "./DatasetTabGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6db077",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a6db077')) {
      api.createRecord('6a6db077', component.options)
    } else {
      api.reload('6a6db077', component.options)
    }
    module.hot.accept("./DatasetTabGeneral.vue?vue&type=template&id=6a6db077&scoped=true&lang=pug", function () {
      api.rerender('6a6db077', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/DatasetTabGeneral.vue"
export default component.exports